<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="goToDetailTransfertArticle" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActionsArticles',
  methods: {
    goToDetailTransfertArticle () {
      this.$router.push(`/apps/stock/transfert-article/details/${this.params.data._id}`).catch(() => {})
    }
  }
}
</script>
